<template>
  <kye-select
    v-model="selected"
    :disabled="disabled"
    :filterable="column.filterable !== false"
    :default-first-option="column.defaultFirstOption !== false"
    :remote="column.remote"
    :remote-method="remoteMethod"
    :loading="loading"
    :placeholder="column.placeholder"
    v-bind="$attrs"
    ref="select"
    @visible-change="visibleChange"
    @change="changeSelect"
    @clear="clearSelect">
    <kye-option
      v-for="(item,index) in selectList"
      :key="index"
      :disabled="item.disabled"
      :label="item.label"
      :value="item.value">
      {{item.label}}
    </kye-option>
  </kye-select>
</template>

<script>
  import mixins from '../../mixins'

  export default {
    mixins: [mixins],
    props: {
      index: Number,
      model: [String, Number, Array],
      remotefn: Function,
      ikey: String,
      column: Object,
      row: Object,
      disabled: Boolean
    },
    data () {
      return {
        selected: '',
        selectList: [],
        loading: false,
        selectTimer: null,
        selectValue: '',
        catchData: []
      }
    },
    methods: {
      // 获取远程数据
      remoteMethod (query) {
        const row = this.row
        clearInterval(this.selectTimer)
        // 输入函数防抖
        this.selectTimer = setTimeout(async () => {
          let r = []
          if (query && this.column.remotefn) {
            this.loading = true
            let res = await this.column.remotefn(query, row)
            if (Array.isArray(res) && res.length > 0) {
              r = res
            } else if (res.list && res.list.length > 0 && res.label && res.value) {
              r = this.formateSelect(res)
            }
            this.loading = false
          }
          this.selectList = r
        }, 350)
      },
      // 序列化数据
      formateSelect (data) {
        let { list, label, value } = data
        this.selectValue = value
        this.catchData = list || []
        return list.map(item => ({ label: item[label], value: item[value] }))
      },
      // 选择事件
      changeSelect (val) {
        let data = {}
        let v = this.column.dic ? val : (val || '')
        if (val || val === 0) {
          let labelObj = this.selectList.find(item => item.value === val) || {}
          if (this.selectValue && this.catchData.length > 0) {
            data = this.catchData.find(item => item[this.selectValue] === this.selected)
          } else {
            data = labelObj
          }
        }
        this.$emit('selectRemote', { index: this.index, val: v, column: this.column, data })
      },
      clearSelect () {
        this.$emit('clear', this.selected)
      },
      visibleChange (val) {
        if (val) {
          this.toCustomeSelect()
          this.$nextTick(() => {
          if (this.$refs.select && this.$refs.select.$refs.elSelect) {
            (this.$refs.select.$refs.elSelect.options || []).forEach(opt => {
              if (opt.visible === false) {
                opt.visible = true
              }
            })
          }
        })
        }
      },
      async toCustomeSelect () {
        if (this.column.customData) {
          if (Array.isArray(this.column.customData)) {
            this.selectList = this.column.customData
          } else {
            this.selectList = await this.column.customData(this.row)
          }
        }
      }
    },
    mounted () {
      this.selected = this.model
      if (this.column.dic) {
        this.selectList = this.lookUpOptions[this.column.dic]
      }
      // 自定义配置
      this.toCustomeSelect()
    },
    beforeDestroy () {
      clearInterval(this.selectTimer)
    },
    watch: {
      model (val) {
        this.selected = val
      },
      column: {
        handler () {
          this.toCustomeSelect()
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/kye-edit-table/select.vue